export function randomItem<T = unknown>(arr: T[]) {
  const randomIndex = Math.floor(Math.random() * arr.length);

  return arr[randomIndex];
}

export function sendAnalyticsEvent(
  eventType: string,
  eventParams?: Record<string, string>
) {
  if (!window.gtag) return;

  window.gtag('event', eventType, eventParams);
}
